/* unplugin-vue-components disabled */import { render } from "./UploadButton.vue?vue&type=template&id=94acec34&scoped=true&ts=true"
import script from "./UploadButton.vue?vue&type=script&lang=ts"
export * from "./UploadButton.vue?vue&type=script&lang=ts"

import "./UploadButton.vue?vue&type=style&index=0&id=94acec34&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94acec34"]])

export default __exports__